import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError, switchMap, Observable, throwError, shareReplay } from 'rxjs';

let refreshTokenInProgress = false;
let tokenRefreshObservable: Observable<any> | null = null;

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.url.includes('/oauth/token')) {
        if (refreshTokenInProgress) {
          // Als er al een refresh bezig is, wacht dan op die Observable
          return tokenRefreshObservable!.pipe(
            switchMap(() => {
              const newToken = authService.getToken();
              const newRequest = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken}`
                }
              });
              return next(newRequest);
            })
          );
        } else {
          refreshTokenInProgress = true;
          // Start een nieuwe token refresh
          tokenRefreshObservable = authService.handleUnauthorizedError(error).pipe(
            shareReplay(1)
          );

          return tokenRefreshObservable.pipe(
            switchMap(() => {
              refreshTokenInProgress = false;
              tokenRefreshObservable = null;
              const newToken = authService.getToken();
              const newRequest = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken}`
                }
              });
              return next(newRequest);
            }),
            catchError((retryError) => {
              refreshTokenInProgress = false;
              tokenRefreshObservable = null;
              // Don't show error toast for auth failures during refresh
              return throwError(() => retryError);
            })
          );
        }
      }
      return throwError(() => error);
    })
  );
};
